import { Modal, ModalProps, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useStartEvent } from "pages/events/queries"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}

const StartEventModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation()
  const startEvent = useStartEvent()
  const handleOk = () => {
    startEvent.mutate(data!, {
      onSuccess() {
        props.onClose()
      },
    })
  }
  return (
    <Modal
      title={t("events.start_event")}
      onCancel={props.onClose}
      okText={t("global.start")}
      cancelText={t("global.cancel")}
      onOk={handleOk}
      confirmLoading={startEvent.isLoading}
      {...props}
    >
      <Typography.Text>{t("events.start_event_description")}</Typography.Text>
    </Modal>
  )
}

export default StartEventModal
